import { IAppState } from '../../redux';

export const selectIsMultiPostingEnabled = (state: IAppState) =>
  Boolean(state.offer.multiposting ? state.offer.multiposting.enabled : false);
